import { createIcon } from '@chakra-ui/icons';
import React from 'react';
export const FacebookIcon = createIcon({
    displayName: 'FacebookIcon',
    viewBox: '0 0 24 24',
    path: (React.createElement("path", { d: "M16.6971 8.66102H13.2514V7.51905C13.2514 5.81045 13.9178 5.15499 15.647 5.15499C16.1825 5.15499 16.6169 5.16762 16.8658 5.19302V2.26221C16.3934 2.13104 15.2421 2 14.5757 2C11.054 2 9.43033 3.66626 9.43033 7.2653V8.65672H7.25415V11.8879H9.43033V22H13.2556V11.8921H16.1067L16.6971 8.66102Z", fill: "currentColor" })),
});
